module.exports = __webpack_public_path__ + "media/images/simplicity-5d786dd8085dc712689480c04fdaf87e.svg";